/* eslint-disable no-console */
import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { PageLayout } from '../layout/PageLayout';
import { AuthCallback } from '../pages/AuthCallback';
import { StreamPage } from '../pages/Stream';

// Dynamically determine the basename for the router.
const getBasename = () => {
	const base = window.location.pathname.replace('/callback', '').replace(/\/$/, '');
	console.log('base=', base);

	return base;
};

export const router = createBrowserRouter(
	createRoutesFromElements([
		<Route key="basePath" path="/" element={<PageLayout />}>
			<Route path="" element={<StreamPage />} />
		</Route>,
		<Route key="auth" path="/callback" element={<AuthCallback />} />,
	]),
	{ basename: getBasename() },
);
